<template>
  <div class="container" style="margin-top: 3cm">
    <h2 class="text-center">关于编辑出版2025《企业现代化管理创新成果汇编》的通知 川企联〔2026〕21号</h2>
    <p class="box_p text-center">
      <span>发布时间： </span>
      <span id="date" style="display: inline-block; margin-left: -10px">
         2026-03-16 14:36:33
        </span>
      <span style="margin-left: 16px">编辑： </span>
      <span id="author" style="display: inline-block; margin-left: -10px">
         管理员
        </span>
    </p>
    <div style="letter-spacing:2px">
      各市州及行业企联（企协）、各成果创造单位、有关企业：<br>
           2025年，在各行业协会、市（州）企联及广大企业协同发力下，我会圆满完成年度成果培育、申报与评审工作，为深入推广优秀管理经验，持续深化管理创新、集智攻坚、总结提升，我会决定编辑出版《2025四川省企业管理现代化创新成果》集。具体内容与要求请下载附件查看正式红头文件。<br><br>
      四川省企业联合会 四川省企业家协会<br>
      2026年03月16日<br><br>
      <dl>
        <dt>附件下载：</dt>
        <dd><a style="color: #1c84c6" href="static/file/川企联〔2026〕21号-关于编辑出版2025《企业现代化管理创新成果汇编》的通知.pdf" download>关于发布2025年度四川省企业管理现代化创新成果的通知</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NoticeDetails2.vue